export const PRODUCT_CATEGORY_LIST_REQUEST = 'PRODUCT_CATEGORY_LIST_REQUEST';
export const PRODUCT_CATEGORY_LIST_SUCCESS = 'PRODUCT_CATEGORY_LIST_SUCCESS';
export const PRODUCT_CATEGORY_LIST_FAIL = 'PRODUCT_CATEGORY_LIST_FAIL';

export const PRODUCT_CATEGORY_CREATE_REQUEST = 'PRODUCT_CATEGORY_CREATE_REQUEST';
export const PRODUCT_CATEGORY_CREATE_SUCCESS = 'PRODUCT_CATEGORY_CREATE_SUCCESS';
export const PRODUCT_CATEGORY_CREATE_FAIL = 'PRODUCT_CATEGORY_CREATE_FAIL';
export const PRODUCT_CATEGORY_CREATE_RESET = 'PRODUCT_CATEGORY_CREATE_RESET';

export const PRODUCT_CATEGORY_UPDATE_REQUEST = 'PRODUCT_CATEGORY_UPDATE_REQUEST';
export const PRODUCT_CATEGORY_UPDATE_SUCCESS = 'PRODUCT_CATEGORY_UPDATE_SUCCESS';
export const PRODUCT_CATEGORY_UPDATE_FAIL = 'PRODUCT_CATEGORY_UPDATE_FAIL';
export const PRODUCT_CATEGORY_UPDATE_RESET = 'PRODUCT_CATEGORY_UPDATE_RESET';

export const PRODUCT_CATEGORY_DELETE_REQUEST = 'PRODUCT_CATEGORY_DELETE_REQUEST';
export const PRODUCT_CATEGORY_DELETE_SUCCESS = 'PRODUCT_CATEGORY_DELETE_SUCCESS';
export const PRODUCT_CATEGORY_DELETE_FAIL = 'PRODUCT_CATEGORY_DELETE_FAIL';
export const PRODUCT_CATEGORY_DELETE_RESET = 'PRODUCT_CATEGORY_DELETE_RESET';
